import { useState } from "react";
import { Exam } from "@/components/ExamComponent";
import { LanguageSelect } from "@/components/LanguageSelect";

export default function ExamOptions() {
  const [selectedSubject, setSelectedSubject] = useState<string | null>(null);
  const [showLanguageSelect, setShowLanguageSelect] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // default language

  const subjects = ["General Knowledge", "Maths", "Reasoning"];

  const examConfig: Record<
    string,
    { endpoint: string; sessionType: string; title: string }
  > = {
    "General Knowledge": {
      endpoint: "api/general_knowledge/random",
      sessionType: "gk",
      title: "General Knowledge Exam",
    },
    Maths: {
      endpoint: "api/mathematics/random",
      sessionType: "maths",
      title: "Mathematics Exam",
    },
    Reasoning: {
      endpoint: "api/reasoning/random",
      sessionType: "reasoning",
      title: "Reasoning Exam",
    },
  };

  const handleSubjectClick = (subject: string) => {
    setSelectedSubject(subject);
    setShowLanguageSelect(true); // open language selection modal
  };

  return (
    <div className="p-6 max-w-4xl mx-auto text-foreground">
      {!selectedSubject ? (
        <div>
          <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-gray-400">
            Choose a Subject
          </h2>

          <ul className="space-y-2">
            {subjects.map((subject) => (
              <li key={subject}>
                <button
                  onClick={() => handleSubjectClick(subject)}
                  className="w-full px-4 py-2 text-left rounded-lg 
                             bg-accent hover:bg-accent/70 
                             text-foreground font-medium
                             border border-border transition"
                >
                  {subject}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <>
          {/* LanguageSelect Modal */}
          {showLanguageSelect && selectedSubject && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
              <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 w-96">
                <LanguageSelect
                  title={selectedSubject}
                  selectedLanguage={selectedLanguage}
                  onLanguageChange={setSelectedLanguage}
                  onStart={() => setShowLanguageSelect(false)}
                  onClose={() => {
                    setShowLanguageSelect(false);
                    setSelectedSubject(null); // back to subject list
                  }}
                />
              </div>
            </div>
          )}

          {/* Exam Component */}
          {!showLanguageSelect && selectedSubject && (
            <Exam
              endpoint={examConfig[selectedSubject].endpoint}
              sessionType={examConfig[selectedSubject].sessionType}
              title={examConfig[selectedSubject].title}
              language={selectedLanguage}
              duration={3600}
              limit={30}
              onExit={() => setSelectedSubject(null)} // back to subject list
            />
          )}
        </>
      )}
    </div>
  );
}
